<div class="data-visualization-container bg-white w-full" [ngClass]="{
  'border rounded-t-lg': !isCanvas,
  'h-full flex flex-col': isCanvas
}">
  <!-- Fixed Toggle Header -->
  <div class="flex items-center justify-between p-3 border-b bg-white w-full" *ngIf="showToggle && !isCanvas">
    <div class="flex items-center space-x-2">
      <!-- Grid/Chart Toggle -->
      <div class="bg-gray-100 rounded-lg p-1 flex">
        <button
          (click)="viewMode !== 'grid' && toggleView()"
          [class]="viewMode === 'grid' ? 'bg-white shadow-sm' : 'hover:bg-gray-200'"
          class="px-3 py-1.5 rounded-md text-sm font-medium transition-colors flex items-center space-x-1"
          [ngClass]="{
            'text-blue-600': viewMode === 'grid',
            'text-gray-600': viewMode !== 'grid'
          }">
          <ui-icon name="table-icon" [class]="viewMode === 'grid' ? 'stroke-blue-600' : 'stroke-gray-600'" size="size-4"></ui-icon>
          <span>Grid</span>
        </button>
        <button
          (click)="viewMode !== 'chart' && toggleView()"
          [class]="viewMode === 'chart' ? 'bg-white shadow-sm' : 'hover:bg-gray-200'"
          class="px-3 py-1.5 rounded-md text-sm font-medium transition-colors flex items-center space-x-1"
          [ngClass]="{
            'text-blue-600': viewMode === 'chart',
            'text-gray-600': viewMode !== 'chart'
          }">
          <ui-icon name="bar-chart" [class]="viewMode === 'chart' ? 'stroke-blue-600' : 'stroke-gray-600'" size="size-4"></ui-icon>
          <span>Chart</span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="columnDefs.length > 0 && rowData.length > 0" style="position: absolute; left: -10000px; top: -10000px; width: 1px; height: 1px; overflow: hidden;">
    <ag-grid-angular
      class="ag-theme-quartz"
      style="width: 1px; height: 1px;"
      [columnDefs]="columnDefs"
      [rowData]="rowData"
      [defaultColDef]="defaultColDef"
      [gridOptions]="hiddenGridOptions"
      (gridReady)="onHiddenGridReady($event)">
    </ag-grid-angular>
  </div>

  <!-- Data Display Area: canvas fills parent; embed uses fixed flex-friendly height (avoid autoHeight + unbounded rows). -->
  <div
    class="data-display-area w-full"
    [ngClass]="{ 'dc-embed-pane flex min-h-0 flex-col overflow-hidden': !isCanvas }"
    [ngStyle]="
      isCanvas
        ? {
            'max-height': '100%',
            height: '100%',
            'overflow-y': 'hidden',
            flex: '1',
          }
        : {}
    "
  >
    <!-- Grid View -->
    <div
      *ngIf="viewMode === 'grid'"
      class="grid-container w-full min-h-0"
      [ngClass]="{
        'h-full min-h-0 flex flex-1 flex-col': !isCanvas,
        'h-full': isCanvas,
        'canvas-grid-wrapper': isCanvas,
      }"
    >
      <ag-grid-angular
        *ngIf="columnDefs.length > 0 && rowData.length > 0"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [domLayout]="isCanvas ? undefined : 'normal'"
        [gridOptions]="isCanvas ? canvasGridOptions : {}"
        (gridReady)="onGridReady($event)"
        (filterChanged)="onFilterChanged()"
        (sortChanged)="onSortChanged()"
        class="ag-theme-quartz text-sm w-full"
        [ngClass]="{ 'canvas-ag-grid': isCanvas, 'dc-embed-ag-grid': !isCanvas }"
        [ngStyle]="isCanvas ? { height: '100%', width: '100%' } : {}"
      >
      </ag-grid-angular>

      <!-- Empty State for Grid -->
      <div *ngIf="!rowData || rowData.length === 0" class="flex items-center justify-center py-12">
        <div class="text-center text-gray-500">
          <ui-icon name="table-icon" class="stroke-gray-400 mx-auto mb-2" size="size-8"></ui-icon>
          <p>No data available</p>
        </div>
      </div>
    </div>

    <!-- Chart View -->
    <div *ngIf="viewMode === 'chart'" class="chart-container flex min-h-0 w-full flex-1 flex-col" [ngClass]="{ 'h-full': isCanvas }">
      <!-- Chart Content -->
      <div *ngIf="filteredRowData && filteredRowData.length > 0" class="chart-wrapper flex min-h-0 w-full flex-1 flex-col">
        <!-- AG Grid Chart Component -->
        <app-ag-grid-chart
          *ngIf="hiddenGridApi"
          [gridApi]="hiddenGridApi"
          [chartType]="agGridChartType"
          [chartModel]="lastKnownChartModel || chartModel"
          (chartModelChange)="onChartModelChange($event)">
        </app-ag-grid-chart>
      </div>

      <!-- Empty State for Chart -->
      <div *ngIf="!filteredRowData || filteredRowData.length === 0" class="flex items-center justify-center py-12">
        <div class="text-center text-gray-500">
          <ui-icon name="bar-chart" class="stroke-gray-400 mx-auto mb-2" size="size-8"></ui-icon>
          <p>No data available to chart</p>
        </div>
      </div>
    </div>
  </div>
</div>
